/**
 * Resolve display channel for footer ticker items.
 * Prefers explicit `channel`; falls back by platform.
 */
export function resolveTickerChannel(item) {
  if (item.channel) {
    return item.channel;
  }

  const platform = String(item.platform || item.source || '').toLowerCase();

  if (platform === 'twitch' && item.url) {
    const match = item.url.match(/twitch\.tv\/([^/?#]+)/i);
    if (match?.[1]) {
      return match[1];
    }
  }

  if (platform === 'kick' && item.url) {
    const match = item.url.match(/kick\.com\/([^/?#]+)/i);
    if (match?.[1]) {
      return match[1];
    }
  }

  if (platform === 'epg' && item.meta?.includes('·')) {
    return item.meta.split('·')[0].trim();
  }

  return null;
}

/**
 * Optional viewer / time suffix (e.g. "137K watching" or "starts 20:15").
 */
export function resolveTickerDetail(item) {
  const platform = String(item.platform || item.source || '').toLowerCase();
  const meta = item.meta || '';

  if (platform === 'epg') {
    if (meta.includes('·')) {
      const after = meta.split('·').slice(1).join('·').trim();
      if (after && after.toLowerCase() !== 'live') {
        return after;
      }
      return null;
    }
    return item.live ? null : (meta || null);
  }

  if (/watching/i.test(meta)) {
    return meta;
  }

  return meta || null;
}
